import { App } from '../App'
import { useAppStoreSelector } from '../hooks/useAppStoreSelector'
import { selectSelectedJourneyId } from '../store/selectors/config'

const JourneyApp = () => {
  const selectedJourneyId = useAppStoreSelector(selectSelectedJourneyId)

  return <App journeyIdOverride={selectedJourneyId} />
}

JourneyApp.displayName = 'JourneyApp'

export default JourneyApp // for lazy loading
